import { render, staticRenderFns } from "./RelAuster.vue?vue&type=template&id=1667a32e&scoped=true"
import script from "./RelAuster.vue?vue&type=script&lang=js"
export * from "./RelAuster.vue?vue&type=script&lang=js"
import style0 from "./RelAuster.vue?vue&type=style&index=0&id=1667a32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667a32e",
  null
  
)

export default component.exports